import cls from "@fvilers/cls";
import { Button } from "@imi/ui/components/Button/Button.js";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import styles from "./ErrorBoundaryActions.module.css";

export type ErrorBoundaryActionsProps = {
  className?: string;
  logout?: boolean;
  retryable?: boolean;
};

export function ErrorBoundaryActions({
  className,
  logout,
  retryable,
}: ErrorBoundaryActionsProps) {
  const { t } = useTranslation("errors", { keyPrefix: "boundaries.actions" });

  return retryable ? (
    <div className={cls(styles.ErrorBoundaryActions, className)}>
      {logout && (
        <Button as={Link} reloadDocument to="/auth/logout" variant="outline">
          {t("logout")}
        </Button>
      )}
      <Button as={Link} reloadDocument to="/" variant="outline">
        {t("home")}
      </Button>
      <Button onClick={() => window.location.reload()}>{t("retry")}</Button>
    </div>
  ) : (
    <div className={cls(styles.ErrorBoundaryActions, className)}>
      {logout && (
        <Button as={Link} reloadDocument to="/auth/logout" variant="outline">
          {t("logout")}
        </Button>
      )}
      <Button as={Link} className={className} reloadDocument to="/">
        {t("home")}
      </Button>
    </div>
  );
}
